import { useState } from "react";
import { Alert, IconButton, Snackbar, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import useCacheKeys from "../../hooks/use-cache-keys";
import { deleteCacheKey } from "../services/cache-service";

const RefreshButton = ({
  mutate,
  cacheKey,
  dataLength,
  tooltipLabel = "Refresh",
}: {
  mutate: () => void;
  cacheKey: string;
  dataLength: number | undefined;
  tooltipLabel?: string;
}) => {
  const { data: cacheData, mutate: mutateCache } = useCacheKeys();

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success",
  );

  const onRefreshClick = async () => {
    try {
      const currentKey = cacheData?.results.find((key) =>
        key.includes(cacheKey),
      );
      if (currentKey) {
        await deleteCacheKey(currentKey);
      }
      setSnackbarMessage("Successful Refresh!");
      setSnackbarSeverity("success");
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Error deleting cache key:", err);

      setSnackbarMessage("Failed to refresh.");
      setSnackbarSeverity("error");
    } finally {
      mutate();
      mutateCache();
      setSnackbarOpen(true);
    }
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <>
      {dataLength !== undefined && dataLength > 0 && (
        <Tooltip title={tooltipLabel}>
          <IconButton aria-label="refresh" onClick={onRefreshClick}>
            <RefreshIcon sx={{ color: "#cccfd1ff" }} />
          </IconButton>
        </Tooltip>
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        key="topcenter"
      >
        <Alert
          onClose={handleClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default RefreshButton;
